/**
 * `/city` entries sometimes include a trailing state abbreviation, e.g. "Columbus (GA)".
 * Dropdown labels show the locality name only; keep the raw string as the option `value`
 * so list/export query params match the backend.
 */
export function cityFilterOptionLabel(raw: string): string {
  return raw.replace(/\s+\([A-Za-z]{2}\)\s*$/, '').trim()
}

/**
 * CRM dumps in `/city` sometimes store street lines or "City 12345" rows as "cities".
 * Those strings sort before real names (digits sort before letters), so merged "All states" lists
 * look broken even when per-state JSON (e.g. GA) is fine in DevTools.
 */
export function isLikelyStreetOrGarbageCityEntry(name: string): boolean {
  const t = name.trim()
  if (!t) return true
  if (/^\d+\s/.test(t)) return true
  if (/\s\d{5}\s*$/.test(t)) return true
  return false
}

/** Drop junk rows; caller dedupes / sorts as needed. */
export function dropJunkCityNames(names: readonly string[]): string[] {
  return names.filter((n) => !isLikelyStreetOrGarbageCityEntry(n))
}
